import { OrganizationStatusEntity } from '../entities/OrganizationStatus';
import { authResource } from './Auth';
export const OrganizationStatusResource = authResource({
    path: '/OrganizationStatuses/:id',
    schema: OrganizationStatusEntity
});
